import React from 'react';
import { Alert, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';

const ZerodhaAuthAlert: React.FC = () => {
    const handleLinkZerodha = async () => {
        try {
            const response = await api.get("/auth/zerodha-url");
            if (response.data.url) {
                window.location.href = response.data.url;
            }
        } catch (err) {
            toast.error("Failed to get login URL");
        }
    };

    return (
        <Alert 
            severity="error" 
            variant="filled" 
            sx={{ mb: 3, borderRadius: 2 }}
            action={
                <Button 
                    color="inherit" 
                    size="small" 
                    variant="outlined"
                    onClick={handleLinkZerodha}
                >
                    Link Zerodha
                </Button>
            }
        >
            <Typography variant="subtitle2" fontWeight="bold">Zerodha Authentication Required</Typography>
            <Typography variant="caption">To view live trades and portfolio data, please link your Zerodha account.</Typography>
        </Alert>
    );
};

export default ZerodhaAuthAlert;
